import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Edit, Trash2 } from "lucide-react";
import { AircraftTypeForm } from "../AircraftTypeForm";
import { AircraftType } from "@/types/flight";

interface AircraftTypeListItemProps {
  aircraftType: AircraftType;
  onEdit: () => void;
  onDelete: (id: string) => void;
}

export function AircraftTypeListItem({ 
  aircraftType, 
  onEdit, 
  onDelete 
}: AircraftTypeListItemProps) {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const handleEditSuccess = () => {
    setIsEditDialogOpen(false);
    onEdit();
  };

  const handleDeleteClick = () => {
    onDelete(aircraftType.id);
  };

  return (
    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg border">
      <div className="flex items-center gap-3">
        <div>
          <div className="font-medium">{aircraftType.name}</div>
          <Badge variant="outline" className="text-xs">
            {aircraftType.code}
          </Badge>
        </div>
      </div>
      
      <div className="flex gap-2">
        <Dialog open={isEditDialogOpen} onOpenChange={setIsEditDialogOpen}>
          <DialogTrigger asChild>
            <Button variant="outline" size="sm">
              <Edit className="h-4 w-4" />
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Edit Aircraft Type</DialogTitle>
            </DialogHeader>
            <AircraftTypeForm 
              aircraftType={aircraftType}
              onSubmit={handleEditSuccess}
            />
          </DialogContent>
        </Dialog>
        
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleDeleteClick}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}